/**
 * @fileoverview Utility functions for the application.
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * A utility function to merge Tailwind CSS classes conditionally.
 * It combines the functionality of `clsx` (for conditional classes) and `tailwind-merge`
 * (to intelligently merge and override conflicting Tailwind classes).
 *
 * @param {...ClassValue[]} inputs A list of classes to merge. Can be strings, objects, or arrays.
 * @returns {string} The final, merged class string.
 *
 * @example
 * cn("p-4 bg-red-500", { "font-bold": true }, "bg-blue-500")
 * // Returns: "p-4 font-bold bg-blue-500" (bg-blue-500 overrides bg-red-500)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
